export default __webpack_public_path__ + "static/23-aecbf30999ca22e63ebc9f36f7a638fc.jpg";